import { render, staticRenderFns } from "./PageHeadline.vue?vue&type=template&id=2e2d4c9e"
import script from "./PageHeadline.vue?vue&type=script&lang=js"
export * from "./PageHeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports